<script>
import Auth from '@/services/auth';
import Breadcrumb from '@/components/ui/breadcrumb/breadcrumb.vue';
import Sidebar from '@/components/sidebar.vue';
import NavToggle from '@/components/nav-toggle.vue';
import Notifications from '@/components/notifications.vue';
import TripSwap from '@/components/trip-swap/index.vue';
import Wallet from '@/components/wallet/index.vue';
import MailPreviewSelect from '@/components/admin/mail-preview-select/mail-preview-select.vue';
import AccountsTable from '@/datatables/accounts-table.vue';
import Dashboard from '@/components/dashboard/index.vue';
import Mypoints from '@/components/mypoints/index.vue';
import Creditscore from '@/components/creditscore/index.vue';
import Members from '@/components/members/index.vue';
import NextCard from '@/components/next-card/index.vue';
import vClickOutside from 'click-outside-vue3';
import Settings from '@/components/settings/index.vue';
import AppNotifications from '@/components/app-notifications.vue';
import Changelog from '@/components/changelog/index.vue';
import GoodDay from '@/components/good-day.vue';
import AffiliateDisclosureModal from '@/modals/affiliate-disclosure-modal.vue';
import FiveTwentyFourModal from '@/modals/five-twenty-four-modal.vue';
import MyNextCardMethodologyModal from '@/modals/my-next-card-methodology.vue';
import Onboarding from '@/components/onboarding.vue';
import TwoFactorToggle from '@/components/auth/two-factor-toggle.vue';
import PhoneNumber from '@/components/phone-number.vue';
import ResetPassword from '@/components/auth/reset-password.vue';
import ChangeEmail from './components/auth/change-email.vue';
import Faq from '@/components/faq.vue';
import Security from '@/components/security/index.vue';
import Support from '@/components/support.vue';
import SupportForm from '@/components/support-form.vue';
import NotificationToggles from '@/components/user-settings/notification-toggles.vue';
import AddWalletUserModal from '@/components/wallet/modals/add-wallet-user.vue';
import AddWalletUserBtn from '@/components/wallet/add-wallet-user-btn.vue';
import EditReward from '@/components/mypoints/modals/edit-reward.vue';
import CompanionPass from '@/components/companion-pass/companion-pass.vue';
import CompanionPassToggle from '@/components/companion-pass/companion-pass-toggle.vue';
import Course from '@/components/courses/course.vue';
import FeaturedTools from '@/components/admin/featured-tools.vue';
import DataSync from '@/components/data-sync/data-sync.vue';
import TravelPlus from '@/components/travel-plus/index.vue';
import LocalRewards from '@/components/users/local-rewards.vue';
import UserAdminActions from '@/components/users/admin-actions.vue';
import ChaseModal from '@/components/popups/chase-modal.vue';

import { mapActions, mapState } from 'pinia';
import { useAppStore } from '@/store/app';
import { useWalletStore } from '@/store/wallet';
import { usePointsStore } from '@/store/points';
import { useDashboardStore } from '@/store/dashboard';
import { normalizeError } from '@/utils/error-handler';
import Icon from './components/ui/icon/icon.vue';

export default {
    components: {
        Breadcrumb,
        Sidebar,
        NavToggle,
        Wallet,
        AccountsTable,
        Notifications,
        Dashboard,
        Mypoints,
        Creditscore,
        Members,
        NextCard,
        Settings,
        AppNotifications,
        Changelog,
        GoodDay,
        AffiliateDisclosureModal,
        FiveTwentyFourModal,
        MailPreviewSelect,
        MyNextCardMethodologyModal,
        Onboarding,
        TwoFactorToggle,
        PhoneNumber,
        ResetPassword,
        ChangeEmail,
        Faq,
        Security,
        Support,
        SupportForm,
        NotificationToggles,
        TripSwap,
        AddWalletUserModal,
        AddWalletUserBtn,
        EditReward,
        CompanionPass,
        CompanionPassToggle,
        Course,
        DataSync,
        FeaturedTools,
        TravelPlus,
        'featured-tools': FeaturedTools,
        'local-rewards': LocalRewards,
        'user-admin-actions': UserAdminActions,
        Icon,
        ChaseModal,
    },
    data: () => ({
        errors: [],
        saving: false,
        loading: false,
        open: true,
        searchOpen: false,
        accountOpen: false,
        cardType: '',
        currentTab: null,
    }),
    directives: {
        ClickOutside: vClickOutside.directive,
    },
    computed: {
        ...mapState(useWalletStore, ['wallet']),
        ...mapState(useAppStore, [
            'onboarded',
            'version',
            'sidebarOpen',
            'userSettings',
            'doDataSync',
        ]),
    },
    methods: {
        ...mapActions(useAppStore, [
            'setInstitution',
            'setUserSettings',
            'setVersion',
            'setOnboarded',
            'setShowAffiliateModal',
        ]),
        ...mapActions(usePointsStore, ['getRewards']),
        ...mapActions(useDashboardStore, ['getNumberOfPoints']),
        logout() {
            const logout = Auth.logout();
            logout
                .then((response) => {
                    localStorage.removeItem('_token');
                    location.href = '/login';
                })
                .catch((e) => {});
        },
        closeAccountDropdown() {
            this.accountOpen = false;
        },
        confirmDelete(e) {
            let conf = confirm('Are you sure you want to delete this?');
            if (!conf) {
                e.preventDefault();
                return false;
            }
        },
        info() {
            axios
                .get('/api/info')
                .then((response) => {
                    this.setVersion(response.data.version);
                })
                .catch((response) => {});
        },
        getUserSettings() {
            axios
                .get('/api/user-settings')
                .then((response) => {
                    this.setUserSettings(response.data);
                    this.setOnboarded(response.data.onboarded);
                })
                .catch((response) => {
                    if (response.status === 401 || response.status === 403) {
                        location.href = '/login?loginstatus=autologout';
                    }
                });
        },
        dataSyncComplete() {
            this.getRewards(true);
            this.getNumberOfPoints();
            console.log('Data sync complete.');
        },
        handleHttpStatus(error) {
            if (!error) return;

            const response = normalizeError(error);
            if (!response) return;

            // Handle validation errors
            if (response.data && typeof response.data.errors !== 'undefined') {
                for (const key in response.data.errors) {
                    this.errors.push(response.data.errors[key][0]);
                }
            }

            // Handle error messages
            if (response.message && response.message.length > 3) {
                if (
                    response.message.includes('404') ||
                    response.message.includes('500')
                ) {
                    this.$notify(
                        {
                            group: 'error',
                            title: 'Error',
                            text:
                                'Sorry, there is a problem trying to complete your request. ' +
                                response.message,
                        },
                        4000
                    );
                }
            }

            // Handle authentication errors
            if (
                response.status &&
                (response.status === 401 || response.status === 403)
            ) {
                location.href = '/login?loginstatus=autologout';
            }
        },
    },
    created() {},
    mounted() {
        this.info();
        this.getUserSettings();

        let $issuingBank = document.getElementById('card-issuing-bank');
        if ($issuingBank) {
            $issuingBank.addEventListener('change', (el) => {
                if (el.target.value !== '') {
                    this.setInstitution(el.target.value);
                }
            });
        }

        let $deletes = document.querySelectorAll('.delete-btn');
        $deletes.forEach((el) => {
            el.addEventListener('click', (e) => {
                let conf = confirm('Are you sure?');

                if (!conf) {
                    e.preventDefault();
                }
                return conf;
            });
        });
    },
};
</script>
